export default [
  {
    header: 'menu.subscriptions-management',
  },
  {
    title: 'menu.pages',
    route: 'admin:pages',
    icon: 'FacebookIcon',
  },
  {
    title: 'instagram.accounts',
    route: 'admin:insta-accounts',
    icon: 'InstagramIcon',
  },
  {
    title: 'menu.receipts',
    route: 'admin:receipts',
    icon: 'DollarSignIcon',
  },
  {
    title: 'menu.accounts',
    route: 'admin:accounts',
    icon: 'UsersIcon',
  },
  {
    title: 'menu.push-notifications',
    route: 'admin:push-notifications',
    icon: 'SendIcon',
  },
  {
    title: 'menu.packages',
    route: 'admin:plans',
    icon: 'TagIcon',
  },
  {
    title: 'menu.page-accounts',
    route: 'admin:page-accounts',
    icon: 'UserIcon',
  },
  {
    title: 'menu.automated-pages-n8n',
    route: 'admin:n8n-pages',
    icon: 'UserIcon',
  },
  {
    title: 'menu.n8n-pages-history',
    route: 'admin:n8n-pages-history',
    icon: 'ListIcon',
  },
  {
    title: 'menu.automated-instagram-n8n',
    route: 'admin:n8n-instagram-accounts',
    icon: 'InstagramIcon',
  },
  {
    title: 'menu.n8n-instagram-history',
    route: 'admin:n8n-instagram-history',
    icon: 'ListIcon',
  },
  /* {
    title: 'menu.errors-list',
    route: 'admin:errors-list',
    icon: 'CommentIcon',
  },
  {
    title: 'menu.commenter-list',
    route: 'admin:commenter-list',
    icon: 'CommentIcon',
  },
  {
    title: 'menu.likers-list',
    route: 'admin:liker-list',
    icon: 'LikeIcon',
  }, */
]
